import { __awaiter } from '../_virtual/_tslib.js';
import { FaqCategories, FaqQuestions } from '../constants/Faq.js';

function getAllCategories() {
    return __awaiter(this, void 0, void 0, function* () {
        return { faqCategs: FaqCategories };
    });
}
function getFaqsByCateg({ categSlug }) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const Faqs = FaqQuestions.filter((faqQuestion) => faqQuestion.category === categSlug);
        return { faqs: Faqs, count: ((_a = Faqs[0]) === null || _a === void 0 ? void 0 : _a.faqQuestions.length) || 0 };
    });
}
const FaqService = { getAllCategories, getFaqsByCateg };

export { FaqService };
//# sourceMappingURL=faq.service.js.map
